<template>
  <div class="row mb-3">
    <div class="col-4">
      <form-group label="Nome completo" :is-invalid="form.errors.nome">
        <input
            v-model="model.nome"
            class="form-control"
            type="text"
            placeholder="Nome completo"
            @blur="model.clearErrors('nome')"
            :class="{'is-invalid' : model.errors.nome}"
            maxlength="100"
        />
      </form-group>
    </div>

    <div class="col-4">
      <form-group label="Email" required :is-invalid="model.errors.email">
        <input
            class="form-control mb-2"
            type="text"
            placeholder="Nome do Email"
            v-model="model.email"
            @blur="model.clearErrors('email')"
            :class="{'is-invalid' : model.errors.email}"
            maxlength="120"
        />
      </form-group>
    </div>

    <div class="col-4">
      <form-group label="Telefone" required :is-invalid="model.errors.telefone">
        <input
            v-model="model.telefone"
            class="form-control mb-2"
            type="text"
            placeholder="Telefone"
            v-input-mask
            data-inputmask="'mask': '(99) 9 9999-9999', 'placeholder': '', 'removeMaskOnSubmit': true, 'showMaskOnHover': false, 'showMaskOnFocus': false"
            @blur="model.clearErrors('telefone')"
            :class="{'is-invalid' : model.errors.telefone}"
            maxlength="120"
        />
      </form-group>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-4">
      <form-group label="CPF" required :is-invalid="model.errors.cpf">
        <input
            class="form-control mb-2"
            type="text"
            placeholder="CPF"
            v-input-mask
            data-inputmask="'mask': '999.999.999-99', 'placeholder': '', 'removeMaskOnSubmit': true, 'showMaskOnHover': false, 'showMaskOnFocus': false"
            v-model="model.cpf"
            @blur="model.clearErrors('cpf'); this.consultaCPF()"
            :class="{'is-invalid' : model.errors.cpf}"
            maxlength="120"
        />
      </form-group>
    </div>

    <div class="col-4">
      <form-group label="Camiseta" required :is-invalid="model.errors.camiseta">
        <select class="form-select"
                v-model="model.camiseta"
                @blur="model.clearErrors('camiseta')"
                :class="{'is-invalid' : model.errors.camiseta}">
          <option value="P">P</option>
          <option value="M">M</option>
          <option value="G">G</option>
          <option value="GG">GG</option>
        </select>
      </form-group>
    </div>

    <div class="col-4">
      <form-group label="Gênero" required :is-invalid="model.errors.genero">
        <select class="form-select"
                v-model="model.genero"
                @blur="model.clearErrors('genero')"
                :class="{'is-invalid' : model.errors.genero}">
          <option value="F">Feminino</option>
          <option value="M">Masculino</option>
          <option value="O">Outro</option>
        </select>
      </form-group>
    </div>
  </div>

  <div class="row mt-3">

  </div>
</template>

<script>
import SubmitButton from "@forms/SubmitButton";
import FormGroup from "@forms/FormGroup";
import axios from "axios";
import {error} from "@settings/toastr";

export default {
  props: {
    form: {
      type: Object
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FormGroup,
    SubmitButton,
  },

  data: _ => ({
    model: {},
  }),

  created() {
    this.init();
  },

  methods: {
    init() {
      this.model = this.form;
    },
    consultaCPF() {
      axios.post(this.route('app.alunos.json.verify'), {cpf: this.model.cpf, aluno_id: this.model.id}).then(response => {
        if (response.data.id) {
          let pre = response.data.genero === 'F' ? 'A aluna ' : 'O aluno ';
          //Existe aluno
          Swal.fire({
            title: 'Atenção',
            html: pre + '<strong>'+response.data.nome +'</strong> também utiliza este CPF. <br><br><strong>Você confirma a alteração?</strong>',
            icon: 'warning',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Confirmar!',
            denyButtonText: `Cancelar`,
          }).then((result) => {
            if (result.isDenied) {
              this.model.cpf = ''
            }
          })
        }
      })
    }
  },
}
</script>
